<h2 mat-dialog-title class="text-center">{{ data.compagnie_name+" : "+data.collaborateur }}</h2>
<mat-dialog-content id="modalDialog" #modalDialog >
<mat-card appearance="outlined" class="main-table-card border-0 shadow-sm mt-5">

  <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>Renvoi</ng-template>
        <mat-card-header class="row mx-1">
            <div class="col-4">
              <h6>Total : 0 F CFA</h6>
            </div>
            <app-search-bar-component class="col-6" (searchBarValue)="applyFilter($event)" appearance="outline"></app-search-bar-component>
            <button matButton (click)="onRenvoi()" [disabled]="renvoiData.length==0" type="button" class="bg-mat-green col-2 py-4">Valider ({{ renvoiData.length }})</button>
        </mat-card-header>

          <mat-card-content class="position-relative p-0 bg-white table-mat-card-content">
            <!--loading-->
            @if (loading) {
            <div class="loading-table-shade">
              <mat-spinner diameter="70" color="primary"></mat-spinner>
            </div>
            }

            <div>
              <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100 custom-premium-table">
                <!-- -->
                <ng-container matColumnDef="assure">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Assure </th>
                  <td mat-cell *matCellDef="let row"  data-label="Assure"> {{row.assure | uppercase}} </td>
                </ng-container>
                <!--
                <ng-container matColumnDef="code">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Code </th>
                  <td mat-cell *matCellDef="let row"  data-label=""> {{row.code}} </td>
                </ng-container>
                -->

                <!-- -->
                <ng-container matColumnDef="immat">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Immatriculation </th>
                  <td mat-cell *matCellDef="let row"  data-label="Immatriculation"> {{row.immatriculation | uppercase }} </td>
                </ng-container>

                <!-- -->
                <ng-container matColumnDef="chassis">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Chassis </th>
                  <td mat-cell *matCellDef="let row"  data-label="Chassis"> {{row.chassis | uppercase }} </td>
                </ng-container>

                <!-- -->
                <ng-container matColumnDef="attestation">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Attestation </th>
                  <td mat-cell *matCellDef="let row"  data-label="Attestation"> {{row.attestation }} </td>
                </ng-container>

                        <!-- -->
                <ng-container matColumnDef="carte_rose">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Carte rose </th>
                  <td mat-cell *matCellDef="let row"  data-label="Carte rose "> {{row.carte_rose }} </td>
                </ng-container>

                        <!-- -->
                <ng-container matColumnDef="periode">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Periode </th>
                  <td mat-cell *matCellDef="let row"  data-label="Periode"> {{row.periode+" jour(s)" }} </td>
                </ng-container>

                        <!-- -->
                <ng-container matColumnDef="prix">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Prix </th>
                  <td mat-cell *matCellDef="let row"  data-label="prix"> </td>
                </ng-container>

                

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true">
                    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()"
                            [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let row"  data-label="">
                      <mat-checkbox (click)="$event.stopPropagation(); selectAssurance(row)"
                                    (change)="$event ? selection.toggle(row) : null"
                                    [checked]="selection.isSelected(row)"
                                    [aria-label]="checkboxLabel(row)">
                      </mat-checkbox>
                  </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">No data matching the filter "{{searchValue()}}"</td>
                </tr>
                    </table>
      </div>              <mat-paginator [pageSizeOptions]="[6, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
            </div>
            <!---->
        </mat-card-content>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>Historique des renvois</ng-template>
        <mat-card-header class="">
            <app-search-bar-component (searchBarValue)="applyFilter($event)" appearance="outline"></app-search-bar-component>
        </mat-card-header>

          <mat-card-content class="position-relative p-0 bg-white table-mat-card-content">
            <!--loading-->
            @if (loading) {
            <div class="loading-table-shade">
              <mat-spinner diameter="70" color="primary"></mat-spinner>
            </div>
            }

            <div>
              <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100 custom-premium-table">
                <!-- -->
                <ng-container matColumnDef="assure">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Assure </th>
                  <td mat-cell *matCellDef="let row"  data-label="Assure"> {{row.assure | uppercase}} </td>
                </ng-container>
                <!--
                <ng-container matColumnDef="code">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Code </th>
                  <td mat-cell *matCellDef="let row"  data-label=""> {{row.code}} </td>
                </ng-container>
                -->

                <!-- -->
                <ng-container matColumnDef="immat">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Immatriculation </th>
                  <td mat-cell *matCellDef="let row"  data-label="Immatriculation"> {{row.immatriculation | uppercase }} </td>
                </ng-container>

                <!-- -->
                <ng-container matColumnDef="chassis">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Chassis </th>
                  <td mat-cell *matCellDef="let row"  data-label="Chassis"> {{row.chassis | uppercase }} </td>
                </ng-container>

                <!-- -->
                <ng-container matColumnDef="attestation">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Attestation </th>
                  <td mat-cell *matCellDef="let row"  data-label="Attestation"> {{row.attestation }} </td>
                </ng-container>

                        <!-- -->
                <ng-container matColumnDef="carte_rose">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Carte rose </th>
                  <td mat-cell *matCellDef="let row"  data-label="Carte rose "> {{row.carte_rose }} </td>
                </ng-container>

                        <!-- -->
                <ng-container matColumnDef="periode">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Periode </th>
                  <td mat-cell *matCellDef="let row"  data-label="Periode"> {{row.periode+" jour(s)" }} </td>
                </ng-container>

                        <!-- -->
                <ng-container matColumnDef="prix">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Prix </th>
                  <td mat-cell *matCellDef="let row"  data-label="prix"> </td>
                </ng-container>

                

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true">
                    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()"
                            [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let row"  data-label="">
                      <mat-checkbox (click)="$event.stopPropagation(); selectAssurance(row)"
                                    (change)="$event ? selection.toggle(row) : null"
                                    [checked]="selection.isSelected(row)"
                                    [aria-label]="checkboxLabel(row)">
                      </mat-checkbox>
                  </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">No data matching the filter "{{searchValue()}}"</td>
                </tr>
                    </table>
      </div>              <mat-paginator [pageSizeOptions]="[6, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
            </div>
            <!---->
        </mat-card-content>
      </mat-tab>
  </mat-tab-group>

</mat-card>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button matButton mat-dialog-close  class="bg-mat-red m-3" >Fermer</button>
</mat-dialog-actions>
